import { skipToken, useQuery } from "@tanstack/react-query";
import type { components } from "@jbnl/api-client";
import { api } from "@/lib/api";

const PLANNING = "/api/seizoenen/{seizoenId}/planning" as const;

export type Planning = components["schemas"]["GepubliceerdePlanningDto"];
export type PlanningDag = components["schemas"]["GepubliceerdeDagDto"];

export const planningKey = (seizoenId: string) =>
  ["planning", seizoenId] as const;

/** A 404 is `null` rather than an error: nothing is published yet, and a concept is not published. */
export function usePlanning(seizoenId?: string) {
  return useQuery({
    queryKey: planningKey(seizoenId ?? ""),
    queryFn: !seizoenId
      ? skipToken
      : async () => {
          const { data, response } = await api.GET(PLANNING, {
            params: { path: { seizoenId } },
          });

          if (response.status === 404) return null;
          return data ?? null;
        },
  });
}
